import { ethers } from "ethers";
import { NETWORK } from "../config";
import getChain from "./getChain";
import perpetualStakingAbi from "./perpetual-staking-abi";
import privateStakeAbi from "./private-stake-abi";
import stakingAbi from "./stakingAbi";
import tokenAbi from "./tokenAbi";
import newStakeAbi from "./new-stake-abi";

function connectToContracts(signer) {
    const selectedChain = getChain()[NETWORK];

    // console.log(selectedChain,'connected contarct.js')

    if (!selectedChain.tokenContractAddress) {
        throw new Error("Token contract address not set");
    }
    const tokenContract = new ethers.Contract(
        selectedChain.tokenContractAddress,
        tokenAbi,
        signer
    );
    if (!selectedChain.stakingContractAddress) {
        throw new Error("Staking contract address not set");
    }

    const stakingContract = new ethers.Contract(
        selectedChain.stakingContractAddress,
        stakingAbi,
        signer
    );

    const stakingContract_35 = new ethers.Contract(
        selectedChain.stakingContractAddress_35_apy,
        stakingAbi,
        signer
    );

    const stakingContract_new = new ethers.Contract(
        selectedChain.stakingContractAddress_new_apy,
        stakingAbi,
        signer
    );
    const stakingContractSelfMaturing = new ethers.Contract(
        selectedChain.stakingContract_selfMaturing_apy,
        perpetualStakingAbi,
        signer
    );

    // New Stake Contract Connection 
    const stakingContractNewStake = new ethers.Contract(
        selectedChain.stakingContract_new_stake,
        newStakeAbi,
        signer
    );

        // New private Stake Contract Connection 

      const stakingContractNewStakePrivate = new ethers.Contract(
        selectedChain.stakingContract_new_stakeprivate,
        newStakeAbi,
        signer
        );
    
    const stakingContractSelfMaturingPrivate = new ethers.Contract(
        selectedChain.stakingContract_selfMaturing_apy_private,
        privateStakeAbi,
        signer
    );
    
    const stakingContractAdditional = new ethers.Contract(
        selectedChain.stakingContractAdditional,
        perpetualStakingAbi,
        signer
    );
    
    
    return [
        tokenContract,
        stakingContractNewStake,
        stakingContractNewStakePrivate,
        stakingContractSelfMaturing,
        stakingContract_new,
        stakingContract_35,
        stakingContract,
        stakingContractSelfMaturingPrivate,
        stakingContractAdditional,
    ];
}

export default connectToContracts;
